import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// 🔥 નવું: GoogleOAuthProvider અહી ઈમ્પોર્ટ કર્યું છે
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 🔥 નવું: આખી એપને GoogleOAuthProvider થી કવર કરી છે */}
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start serviceWorkerRegistration.unregister(); performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// જૂનો કોડ નથી, પણ આ રીતે ઉમેરવાનું છે:
serviceWorkerRegistration.unregister(); // register ની જગ્યાએ unregister કરો